var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotFound"},[_c('v-container',[_c('div',{staticClass:"hit-the-floor"},[_vm._v("404")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }